export type AdvantageIcon = 'exhaustive' | 'easy' | 'premium' | 'innovation';

export type AdvantageData = {
  TITLE: string;
  TAGLINE: string;
  DESCRIPTION: string;
  FOOTER?: string;
  ITEMS: readonly string[];
  ICON: AdvantageIcon;
  FORMAT_PLUS_LABEL?: boolean;
};

export const EXHAUSTIVE = {
  TITLE: 'Exhaustivité',
  TAGLINE: 'Tout votre cabinet, enfin centralisé',
  DESCRIPTION:
    "zLawyer regroupe l'ensemble des fonctionnalités essentielles à la gestion de votre cabinet, au sein d'un outil unique, conçu pour les avocats.",
  FOOTER: 'Une plateforme complète pour gérer, organiser et piloter votre activité au quotidien.',
  ICON: 'exhaustive',
  FORMAT_PLUS_LABEL: true,
  ITEMS: [
    'Dossiers, temps et facturation',
    'Honoraires, frais et débours',
    'Facturation électronique conforme',
    'Gestion documentaire, emails et tâches',
    'Tableaux de bord et indicateurs clés',
    'Tamponnage numérique des pièces',
    'Relances, trésorerie et rapprochement bancaire',
    'Rapports financiers et performance du cabinet',
    'LCB-FT : conformité anti-blanchiment',
    'Et + encore...',
  ],
} as const satisfies AdvantageData;

export const SIMPLICITY = {
  TITLE: 'Simplicité',
  TAGLINE: 'Un logiciel puissant, sans complexité',
  DESCRIPTION:
    'Un outil facile à utiliser, à déployer et à faire évoluer. Concentrez-vous sur vos dossiers, pas sur l’outil.',
  ICON: 'easy',
  FORMAT_PLUS_LABEL: true,
  ITEMS: [
    'Saisie des temps et facturation fluides',
    'Paramétrage adapté à votre pratique',
    'Abonnement flexible, sans engagement',
    'Tarification simple, sans surprise',
    'Interface intuitive, prise en main immédiate',
  ],
} as const satisfies AdvantageData;

export const SERVICE = {
  TITLE: 'Service Premium',
  TAGLINE: 'Un accompagnement à la hauteur de vos exigences',
  DESCRIPTION:
    "Chez zLawyer, le service ne se limite pas à un support : c'est un véritable engagement.",
  FOOTER: 'Un partenaire fiable, impliqué à vos côtés au quotidien.',
  ICON: 'premium',
  ITEMS: [
    "Équipe experte dédiée aux cabinets d'avocats",
    'Service et équipe basés en France dans nos bureaux',
    'Accompagnement personnalisé sans surcoût',
    'Support client réactif et disponible',
  ],
} as const satisfies AdvantageData;

export const INNOVATION = {
  TITLE: 'Évolutif & Innovant',
  TAGLINE: 'Un logiciel qui progresse avec vous',
  DESCRIPTION: 'zLawyer évolue en continu grâce à une démarche active de R&D.',
  FOOTER:
    'Un logiciel toujours à jour, conçu pour accompagner durablement la performance de votre cabinet.',
  ICON: 'innovation',
  ITEMS: [
    'Fonctionnalités performantes et fiables',
    'Évolutions guidées par vos usages',
    'Améliorations régulières',
  ],
} as const satisfies AdvantageData;

export const ADVANTAGES: readonly AdvantageData[] = [EXHAUSTIVE, SIMPLICITY, SERVICE, INNOVATION];
